import React from "react";
import _ from "lodash";
import { renderLayout } from "schema/ThemeSet.react";

import { Segment, Icon } from "semantic-ui-react";
import OptionButton from "slides/components/OptionButton.react";
import RangeSlider from "slides/components/RangeSlider.react";

export default class Qualification extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sliderVals: _.map(this.props.data.rangeselect, (slider) => {
                return (
                    (parseFloat(slider.maxValue) +
                        parseFloat(slider.minValue)) /
                    2
                );
            }),
            result: null,
            showResult: true,
        };
    }

    handleSlideComplete = (index, value) => {
        let sliderPos = _.cloneDeep(this.state.sliderVals);
        sliderPos[index] = value;
        this.setState({ sliderVals: sliderPos, result: null });
    };

    handleSubmit = () => {
        let formula = `IF(${this.props.data.criteria},TRUE,FALSE)`;
        let varMap = [
            "varA",
            "varB",
            "varC",
            "varD",
            "varE",
            "varF",
            "varG",
            "varH",
            "varI",
            "varJ",
            "varK",
            "varL",
            "varM",
            "varN",
            "varO",
            "varP",
            "varQ",
            "varR",
            "varS",
            "varT",
            "varU",
            "varV",
            "varW",
            "varX",
            "varY",
            "varZ",
        ];
        _.each(varMap, (thisVar, idx) => {
            let replacee = new RegExp(thisVar, "g");
            formula = formula.replace(replacee, this.state.sliderVals[idx]);
        });
        formula = formula.replace(/&lt;/g, "<").replace(/&gt;/g, ">");
        this.props.evalFormula(formula).then((data) => {
            if (data.error) {
                this.setState({ result: "err" });
            } else {
                this.setState({ result: data.result });
            }
        });
    };

    handleContinue = () => {
        this.props.trackInteraction({
            correct: this.state.result,
            response: this.state.sliderVals,
        });
    };

    render() {
        let resultBox = {
            fontSize: "1.25em",
            marginBottom: "15px",
        };
        let isPortrait =
            this.props.mobileView || window.innerHeight > window.innerWidth;
        let LayoutRender = renderLayout(isPortrait, this.props.layout);

        let mappedOptions = _.map(
            this.props.data.rangeselect,
            (slider, index) => {
                return (
                    <RangeSlider
                        {...this.props}
                        index={index}
                        key={"slider-" + index}
                        slider={slider}
                        sliderValue={this.state.sliderVals[index]}
                        handleSlide={this.handleSlideComplete}
                    />
                );
            }
        );
        let mainContent = (
            <div>
                {mappedOptions}
                <br />
                <OptionButton
                    {...this.props}
                    secondary={true}
                    name="Submit"
                    handleClick={this.handleSubmit}
                />
                {this.state.result != null && (
                    <Segment
                        color={
                            this.state.result && this.state.result !== "err"
                                ? "green"
                                : "red"
                        }
                    >
                        {!this.state.showResult ? (
                            <div style={resultBox}>
                                <Icon name="question" /> Are you sure?
                            </div>
                        ) : this.state.result ? (
                            this.state.result === "err" ? (
                                <div style={resultBox}>
                                    <Icon name="exclamation" /> Error
                                </div>
                            ) : (
                                <div style={resultBox}>
                                    <Icon name="check" /> Okay (This won't show
                                    for the audience)
                                </div>
                            )
                        ) : (
                            <div style={resultBox}>
                                <Icon name="close" /> Not Okay (This won't show
                                for the audience)
                            </div>
                        )}
                        <OptionButton
                            {...this.props}
                            name="Continue"
                            handleClick={this.handleContinue}
                        />
                    </Segment>
                )}
            </div>
        );
        return (
            <div className="full-height">
                <LayoutRender
                    {...this.props}
                    title={"Choose all right options:"}
                    mainContent={mainContent}
                />
            </div>
        );
    }
}
